import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import AssortimentMenu from '../AssortimentMenu'
import CompanyMenu from '../CompanyMenu'
import ServiceMenu from '../ServiceMenu'
import { Number } from '../../../styles/defaults'
import { ChevronDown } from '../../Icons'
import { Wrap, Item, IconContainer } from './styles'

class PageNav extends Component {

  handleClickAssort(e) {
    this.props.onClickAssort(e)
  }

  handleClickCompany(e) {
    this.props.onClickCompany(e)
  }

  handleClickService(e) {
    this.props.onClickService(e)
  }

  render() {
    const current = this.props.history.location.pathname
    const { permissions } = this.props

    return (
      <Wrap>
        <Item current={current === '/'}>
          <Link to="/">Dashboard</Link>
        </Item>

        {permissions.viewAssortiment ? (
          <Item
            active={this.props.assortActive}
            onClick={this.handleClickAssort.bind(this)}
            current={current === '/assortiment' || current.includes('/assortiment')}
          >
            <a>Assortiment</a>

            <IconContainer>
              <ChevronDown size="" />
            </IconContainer>

            <AssortimentMenu onClickLink={this.handleClickAssort.bind(this)} />
          </Item>
        ) : null}

        {permissions.viewOrders ? (
          <Fragment>
            <Item current={current === '/bestellijst' || current.includes('/bestellijst')}>
              <Link to="/bestellijst">Mijn bestellijst</Link>
              {this.props.nrOfOrders ? ( <Number>{this.props.nrOfOrders}</Number> ) : null}
            </Item>
          </Fragment>
        ) : null}

        {permissions.viewBranch ? (
          <Item
            active={this.props.companyActive}
            onClick={this.handleClickCompany.bind(this)}
            current={current === '/mijn-bedrijf' || current.includes('/mijn-bedrijf')}
          >
            <a>Mijn bedrijf</a>

            <IconContainer>
              <ChevronDown size="" />
            </IconContainer>

            <CompanyMenu permissions={this.props.permissions} onClickLink={this.handleClickCompany.bind(this)} />
          </Item>
        ) : null}

          <Item
            active={this.props.serviceActive}
            onClick={this.handleClickService.bind(this)}
            current={current === '/klantenservice' || current.includes('/klantenservice')}
          >
            <a>Klantenservice</a>

            <IconContainer>
              <ChevronDown size="" />
            </IconContainer>

            <ServiceMenu permissions={this.props.permissions} onClickLink={this.handleClickService.bind(this)} />
          </Item>


        {permissions.viewAgenda ? (
          <Item current={current === '/agenda'}>
            <Link to="/agenda">Agenda</Link>
          </Item>
        ) : null}
      </Wrap>
    )
  }
}

export default withRouter(PageNav)



// WEBPACK FOOTER //
// ./src/components/Header/PageNav/index.js